import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

var Title = function Title(_ref) {
  var header = _ref.header;

  if (isNil(header)) {
    return '';
  }
  return React.createElement(
    'b',
    null,
    React.createElement(
      'i',
      null,
      header
    ),
    '\xA0'
  );
};

Title.propTypes = process.env.NODE_ENV !== "production" ? {
  header: PropTypes.string
} : {};

export default Title;